module.exports = __webpack_public_path__ + "img/126.46e7eb98.jpg";